import ChoiceCard from "components/ChoiceCard";

/** A Yes and No pair as the whole answer to a question: two equal
 * halves of the row, styled as the form's other option cards. */
export default function YesNoChoice({
  label,
  value,
  onChoose,
}: {
  label: string;
  value: boolean | null;
  onChoose: (answer: boolean) => void;
}) {
  return (
    <div role="group" aria-label={label} className="grid grid-cols-2 gap-3">
      <ChoiceCard
        centered
        tone="daisy"
        size="lg"
        selected={value === true}
        onSelect={() => onChoose(true)}
      >
        Yes
      </ChoiceCard>
      <ChoiceCard
        centered
        tone="daisy"
        size="lg"
        selected={value === false}
        onSelect={() => onChoose(false)}
      >
        No
      </ChoiceCard>
    </div>
  );
}
